import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';
import {Helmet} from 'react-helmet';
import _find from 'lodash/find';
import {getDisclaimers} from '../../actions';
import {states} from '../../lib/config';
import styles from './Disclaimer.scss';

const avmVisibleOnPages = ['propertyDetail'];
const schoolDataVisibleOnPages = ['propertyDetail'];
const absVisibleOnPages = ['propertyDetail', 'suburbResearch', 'suburbProfile'];
const liveabilityVisibleOnPages = ['propertyDetail'];

const Disclaimer = (props) => {
  const dateToday = moment();
  const {page, stateCodeList, disclaimers, getDisclaimers} = props;

  const [isAvmDisclaimerDisplayed, setAvmDisclaimerDisplay] = useState(false);
  const [isSchoolDisclaimerDisplayed, setSchoolDisclaimerDisplay] = useState(false);
  const [isAbsDisclaimerDisplayed, setAbsDisclaimerDisplay] = useState(false);
  const [isLiveabilityDisclaimerDisplayed, setLiveabilityDisclaimerDisplay] = useState(false);

  useEffect(() => {
    let shouldShowAvmDisclaimer = avmVisibleOnPages.includes(page);
    let shouldShowSchoolDisclaimer = schoolDataVisibleOnPages.includes(page);
    let shouldShowAbsDisclaimer = absVisibleOnPages.includes(page);

    setAvmDisclaimerDisplay(shouldShowAvmDisclaimer);
    setSchoolDisclaimerDisplay(shouldShowSchoolDisclaimer);
    setAbsDisclaimerDisplay(shouldShowAbsDisclaimer);
    setLiveabilityDisclaimerDisplay(liveabilityVisibleOnPages.includes(page));

    let payload = {
      avm: shouldShowAvmDisclaimer,
      school: shouldShowSchoolDisclaimer,
      abs: shouldShowAbsDisclaimer,
    };

    getDisclaimers(payload);
  }, []);

  useEffect(() => {
    if (stateCodeList?.length > 0) {
      let stateList = [];
      stateCodeList.forEach(stateCode => stateList.push(stateCode.toLowerCase()));
      const payload = {
        stateList: stateList,
      };
      getDisclaimers(payload);
    }
  }, [stateCodeList?.length]);

  const getFullStateName = (stateCode) => {
    return _find(states, {'code': stateCode.toLowerCase()}).label;
  };

  return (
    disclaimers.status === 'success'?
      <div className="smText">
        <Helmet>
          <meta http-equiv="last-modified" content={dateToday.format('YYYY-MM-DD')} />
        </Helmet>
        <div className="bold600">Cotality Copyright and Legal Disclaimers about Property Data</div>
        <div className={styles.disclaimerBody}>
          <p className={'m-0 ' + styles.copyright} dangerouslySetInnerHTML={{__html: disclaimers.content.copyright}}></p>
          {page === 'suburbProfile' ? <p>Last Updated: {dateToday.format('DD/MM/YYYY')}</p> : null}
          <div className="mt-3">
            <span className="bold600">Disclaimer</span>
            <div dangerouslySetInnerHTML={{__html: disclaimers.content.general}}></div>
          </div>

          {stateCodeList?.map(stateCode => {
            return disclaimers.content['state_' + stateCode.toLowerCase()] ?
              <div className="mt-3" key={stateCode}>
                <span className="bold600">{getFullStateName(stateCode)} data</span>
                <div dangerouslySetInnerHTML={{__html: disclaimers.content['state_' + stateCode.toLowerCase()]}}></div>
              </div>
              : null;
          })}

          {isAvmDisclaimerDisplayed ? <div className="mt-3">
            <span className="bold600">Valuations and Estimates</span>
            <div dangerouslySetInnerHTML={{__html: disclaimers.content.avm}}></div>
          </div> : null}

          {isSchoolDisclaimerDisplayed ? <div className="mt-3">
            <span className="bold600">School data and Content</span>
            <div className="m-0" dangerouslySetInnerHTML={{__html: disclaimers.content.content}}></div>
          </div> : null}

          {isAbsDisclaimerDisplayed ? <div className="mt-3">
            <span className="bold600">ABS data</span>
            <div className="m-0" dangerouslySetInnerHTML={{__html: disclaimers.content.ABSAU}}></div>
          </div> : null}

          {isLiveabilityDisclaimerDisplayed ? <div className="mt-3">
            <span className="bold600">Liveability information</span>
            <div className="m-0">The Liveability Score is a rating (out of 10) provided by Propella.ai Pty Ltd as a guide about how "well-connected" properties are in certain local areas. The Liveability Score is based on statistical data about a local area in which a property is located including the distance to and number of available facilities and services (including schools, parklands, health services, shopping and public transport) (Liveability Data). The Liveability Data and Liveability Score has not been verified or confirmed by Cotality, is not available for all properties, and is of a general nature and should not be construed as specific advice or relied upon in lieu of appropriate professional advice. Given the relative nature of the Liveability Score, propella.ai anticipate that scores for individual properties will change over time.</div>
          </div> : null}
        </div>
      </div>
      : null
  );
};

Disclaimer.propTypes = {
  stateCodeList: PropTypes.array,
  page: PropTypes.string,
  disclaimers: PropTypes.object,
  getDisclaimers: PropTypes.func,
};

const mapStateToProps = (state) => ({disclaimers: state.disclaimers});
const mapDispatchToProps = {getDisclaimers};
export default connect(mapStateToProps, mapDispatchToProps)(Disclaimer);
